import { createContext, useContext } from "react";
import type { PageGuidanceId } from "@/content/guidance/pageGuidance";

export interface PageGuidanceContextValue {
  pageId: PageGuidanceId | null;
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  provided: boolean;
}

export const PageGuidanceContext = createContext<PageGuidanceContextValue>({
  pageId: null,
  enabled: true,
  setEnabled: () => {},
  provided: false,
});

export function usePageGuidance() {
  return useContext(PageGuidanceContext);
}
